import { PortrayalResultErrors } from "@/core/portrayal/domain/portrayalErrors";

const errorKeyMap = {
  [PortrayalResultErrors.BlurredImageError]: "common.onboarding.register-documents.scan-ko.blurred_image_error",
  [PortrayalResultErrors.DocumentClassificationError]:
    "common.onboarding.register-documents.scan-ko.document_classification_error",
  [PortrayalResultErrors.ValidasError]: "common.onboarding.register-documents.scan-ko.validas_error",
  default: "common.onboarding.register-documents.scan-ko.unknown",
};

const getBaseTranslationKey = (reason: string) => errorKeyMap[reason] ?? errorKeyMap.default;

export const getTitleKey = (reason: string) => `${getBaseTranslationKey(reason)}.title`;
export const getSubtitleKey = (reason: string) => `${getBaseTranslationKey(reason)}.subtitle`;
